export const GetYouthAdvisoryCouncilSelector = ({
  youthadvisorycouncil: { getYouthAdvisoryCouncil }
}) => getYouthAdvisoryCouncil;

export const PostYouthAdvisoryCouncilSelector = ({
  youthadvisorycouncil: { postYouthAdvisoryCouncil }
}) => postYouthAdvisoryCouncil;
